import { authorizedInstance } from "../config/axios"

export const getOrdersByAccessionNumber = async ({
  accessionNumber,
  patientIssuer,
}) => {
  const response = await authorizedInstance.get(
    `/order/track-order?accessionNumber=${accessionNumber}&patientIssuer=${patientIssuer}`
  )
  return response.data
}

export const getReportMessageText = async (
  InboundMessageId,
  InboundMessageTextId
) => {
  const response = await authorizedInstance.get(
    `/order/getReportMessageText?InboundMessageId=${InboundMessageId}&InboundMessageTextId=${InboundMessageTextId}`
  )
  return response.data
}

export const getOrderMessageText = async (
  OrderId,
  OrderTextId,
  source,
  PatientIssuer
) => {
  const response = await authorizedInstance.get(
    `/order/getOrderMessageText?OrderId=${OrderId}&OrderTextId=${OrderTextId}&source=${source}&PatientIssuer=${PatientIssuer}`
  )
  return response.data
}

export const getAckMessageText = async (
  OrderId,
  OrderAckId,
  source,
  PatientIssuer
) => {
  const response = await authorizedInstance.get(
    `/order/getAckMessageText?OrderId=${OrderId}&OrderAckId=${OrderAckId}&source=${source}&PatientIssuer=${PatientIssuer}`
  )
  return response.data
}
